// extracted by mini-css-extract-plugin
module.exports = {"container":"Map_style_container__QxxmO","map_search":"Map_style_map_search__3Qpqp"};